const TEE = "M70 30 L110 18 Q150 40 190 18 L230 30 L285 75 L255 120 L228 103 L228 330 L72 330 L72 103 L45 120 L15 75 Z";
const HOODIE = "M75 40 Q100 5 150 5 Q200 5 225 40 L280 80 L268 290 L242 290 L238 120 L232 120 L232 335 L68 335 L68 120 L62 120 L58 290 L32 290 L20 80 Z";

// Print zones in viewBox units (300x350)
const ZONES = {
  Front: { x: 100, y: 95, w: 100, h: 120 },
  Back: { x: 95, y: 90, w: 110, h: 150 },
  "Left Chest": { x: 165, y: 90, w: 38, h: 38 },
  "Right Chest": { x: 97, y: 90, w: 38, h: 38 },
  Sleeve: { x: 240, y: 70, w: 26, h: 26 },
  "Full Front and Back": { x: 85, y: 85, w: 130, h: 180 },
};

export const COLORS = { "Jet Black": "#0d0d0d", White: "#f2f2f2", "Heather Grey": "#8f8f8f", Navy: "#1b2340", Olive: "#4b5320", Maroon: "#5a1020", "Neon Lime": "#C6FF00", Sand: "#c9b48f" };

export function GarmentPreview({ garment, color, placement, art }) {
  const hood = /hoodie|sweatshirt/i.test(garment);
  const z = ZONES[placement] || ZONES.Front;
  const fill = COLORS[color] || "#0d0d0d";
  const light = ["White", "Neon Lime", "Sand"].includes(color);
  return (
    <div className="relative bg-[#121212] border border-[#232323] aspect-[6/7] w-full grain" data-testid="garment-preview">
      <svg viewBox="0 0 300 350" className="w-full h-full">
        <defs><linearGradient id="shade" x1="0" x2="1"><stop offset="0" stopColor="#000" stopOpacity=".25" /><stop offset=".5" stopColor="#fff" stopOpacity=".06" /><stop offset="1" stopColor="#000" stopOpacity=".3" /></linearGradient></defs>
        <path d={hood ? HOODIE : TEE} fill={fill} stroke={light ? "#bbb" : "#333"} strokeWidth="1.5" />
        <path d={hood ? HOODIE : TEE} fill="url(#shade)" />
        {hood && /hoodie/i.test(garment) && <path d="M120 40 Q150 75 180 40" fill="none" stroke={light ? "#999" : "#444"} strokeWidth="2" />}
        {hood && /hoodie/i.test(garment) && <rect x="105" y="240" width="90" height="45" rx="6" fill="none" stroke={light ? "#aaa" : "#2a2a2a"} strokeWidth="1.5" />}
        <rect x={z.x} y={z.y} width={z.w} height={z.h} fill="none" stroke="#C6FF00" strokeDasharray="4 3" strokeWidth="1" opacity=".8" />
        {art && <image href={art} x={z.x} y={z.y} width={z.w} height={z.h} preserveAspectRatio="xMidYMid meet" />}
        {!art && <text x={z.x + z.w / 2} y={z.y + z.h / 2} fill="#C6FF00" fontSize="8" textAnchor="middle" fontFamily="monospace">YOUR ART</text>}
        <text x="150" y="345" fill="#666" fontSize="7" textAnchor="middle" fontFamily="monospace">{garment.toUpperCase()} · {placement.toUpperCase()} VIEW</text>
      </svg>
      <span className="absolute top-3 left-3 eyebrow text-[10px]">LIVE PREVIEW</span>
    </div>
  );
}
